/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CHARACTERISTIC_VALUES, CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.process.title]: '',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Cambio velocidad Riesgo Error 800',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Cambio velocidad Error TELCO',
      [STRING_KEYS.stepTitles.deviceInstallation]: 'Necesitas nuevo equipamiento para tu cambio de velocidad',
      [STRING_KEYS.stepTitles.afterSaleParentProductSelector]: 'Dirección de instalación',
      [STRING_KEYS.deviceInstallation.infoBarData1.infoText]: '',
      [STRING_KEYS.deviceInstallation.infoBarData2.infoText]: 'Indica como quieres realizar la instalación',
      [STRING_KEYS.summary.title]: 'Cambio de velocidad',
      [STRING_KEYS.summary.actionTitle[CHARACTERISTIC_VALUES.SPEED['300MB']]]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.actionTitle[CHARACTERISTIC_VALUES.SPEED['600MB']]]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.actionTitle[CHARACTERISTIC_VALUES.SPEED['1GB']]]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.actionTitle[CHARACTERISTIC_VALUES.SPEED['2GB']]]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.actionTitle[CHARACTERISTIC_VALUES.SPEED['10GB']]]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.oneClick.mainMsg]: 'Una vez finalices el pedido, la nueva configuración estará disponible en unas horas.',
      [STRING_KEYS.summary.oneClick.actionMsg.default]: '',
      [STRING_KEYS.summary.oneClick.actionMsg[CHARACTERISTIC_VALUES.SPEED['300MB']]]: '',
      [STRING_KEYS.summary.oneClick.actionMsg[CHARACTERISTIC_VALUES.SPEED['600MB']]]: '',
      [STRING_KEYS.summary.oneClick.actionMsg[CHARACTERISTIC_VALUES.SPEED['1GB']]]: '',
      [STRING_KEYS.summary.oneClick.actionMsg[CHARACTERISTIC_VALUES.SPEED['2GB']]]: '',
      [STRING_KEYS.summary.oneClick.actionMsg[CHARACTERISTIC_VALUES.SPEED['10GB']]]: '',
      [STRING_KEYS.summary.afterSaleParentProductSelected.phoneNumberLabel]: '',
      [STRING_KEYS.confirmation.subtitle]: 'Puedes hacer seguimiento de tu solicitud en tu área privada.',
      [STRING_KEYS.legalNSubmit.buttonText]: 'Confirmar cambio',
      [STRING_KEYS.summary.installation.advice.title]: 'Información adicional:',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: 'Te llamaremos para que un técnico vaya a tu domicilio. Hasta que no esté instalado el nuevo router no disfrutarás de la nueva velocidad.',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]]: 'Te enviaremos el router para que puedas disfrutar de tu nueva velocidad. Hasta que no lo instales no será efectivo el cambio de velocidad.',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]]: 'Te enviaremos el router para que puedas disfrutar de tu nueva velocidad. Hasta que no lo instales no será efectivo el cambio de velocidad.',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.risk.subject]: 'TELCOBI Cambio velocidad Riesgo Error 800 AU',
      [STRING_KEYS.se.order.subject]: 'TELCOBI Cambio velocidad Error TELCO AU',
    },
  },
};
